export default function CTABand() {
  return (
    <section className="bg-background-100 px-6 lg:px-10 py-12 md:py-16 border-t border-background-200">
      <div className="rounded-xl bg-primary-500 text-background-50 px-6 md:px-10 py-8 md:py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <span className="font-label text-[11px] tracking-[0.2em] uppercase text-primary-100">
            Start Browsing
          </span>
          <h4 className="mt-2 font-heading font-bold text-xl md:text-2xl leading-snug">
            先看索引，再挑一集，找片不再靠翻。
          </h4>
          <p className="mt-2 text-sm text-primary-100 max-w-xl leading-relaxed">
            从专题合集索引或资源速查开始，几分钟就能定位到当下想看的那一条。
          </p>
        </div>
        <div className="flex flex-wrap gap-3 shrink-0">
          <a
            href="#index"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-list-check-2"></i>
            打开专题索引
          </a>
          <a
            href="#lookup"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-primary-200 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-eye-line"></i>
            资源速查
          </a>
        </div>
      </div>
    </section>
  );
}